import createBaseLayer from './base-layer';

export default (props, model) => {
  const self = createBaseLayer(model);

  // Type is a layer attribute for tuning layers otherwise as a node (geez...)
  model.Type = props.Type;

  model.layerType = 'tuning';

  // hack alert. Todo: standardize approach of identifying layer type
  model.isTuningLayer = true;

  return self;
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/layer/types/tuning-layer.js